<div class="tab-container">
  <ng-content select="mat-tab-group"></ng-content>
  <div class="tab-buttons">
    <ng-content select="[tab-buttons]"></ng-content>
  </div>
</div>
